export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 09 Impulse Purchase (Part 1).fcc1c92f.mp3";